import { useRef } from "react";

const useCarousel = () => {
  const sliderRef = useRef(null);

  const next = () => {
    sliderRef.current?.slickNext();
  };
  const slideToIndex = (index) => {
    sliderRef.current?.slickGoTo(index, false);
  };

  const prev = () => {
    sliderRef.current?.slickPrev();
  };

  return { sliderRef, next, prev, slideToIndex };
};

export default useCarousel;
